module.exports = __webpack_public_path__ + "images/white-add-button-icon.svg";